import {
  Document,
  Font,
  Page,
  StyleSheet,
  Text,
  View,
} from '@react-pdf/renderer'
import { t } from 'i18next'

import { UrideLogo } from './UrideLogo'

Font.register({
  family: 'Satisfy',
  src: 'https://fonts.gstatic.com/s/satisfy/v6/kteN-TiU7KwgPz3aaBeTSQ.ttf',
})

const styles = StyleSheet.create({
  bodyText: {
    lineHeight: 1.5,
    marginBottom: 20,
  },
  bold: {
    fontWeight: 'bold',
  },
  companyInfo: {
    marginBottom: 20,
    marginTop: 20,
  },
  date: {
    marginBottom: 20,
  },
  email: {
    marginTop: 40,
  },
  managerName: {
    fontFamily: 'Satisfy',
    fontSize: 24,
  },
  page: {
    fontSize: 12,
    padding: 40,
  },
  signature: {
    marginTop: 10,
  },
  viewer: {
    height: '100vh',
    width: '100%',
  },
})

type Props = {
  averageEarnings: number
  birthDate: string
  date: string
  driverName: string
  firstTripDate: string
  managerEmail: string
  managerName: string
}

export const DriverLetter = ({
  averageEarnings,
  birthDate,
  date,
  driverName,
  firstTripDate,
  managerEmail,
  managerName,
}: Props) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <UrideLogo />
      <View style={styles.companyInfo}>
        <Text>Uride</Text>
        <Text>{t('earnings.driver_letter.header.address')}</Text>
        <Text>Thunder Bay, ON</Text>
        <Text>Canada</Text>
        <Text>P7B3C2</Text>
      </View>

      <Text style={styles.date}>{date}</Text>

      <View style={styles.bodyText}>
        <Text>{t('earnings.driver_letter.body.text1')}</Text>
        <Text>
          {t('earnings.driver_letter.body.text2')}{' '}
          <Text style={styles.bold}>{driverName}</Text>
          {t('earnings.driver_letter.body.text3', {
            averageEarnings,
            birthDate,
            firstTripDate,
          })}
        </Text>
        <Text>{t('earnings.driver_letter.body.text4')}</Text>
      </View>

      <View style={styles.signature}>
        <Text>{t('earnings.driver_letter.signature.text1')}</Text>
      </View>
      <View style={styles.email}>
        <Text style={styles.managerName}>{managerName}</Text>
        <Text>{t('earnings.driver_letter.footer.text1')}</Text>
        <Text>
          {t('earnings.driver_letter.footer.text2', { managerEmail })}
        </Text>
      </View>
    </Page>
  </Document>
)
